<div class="">
  <div class="row no-gutters">
    <div class="d-md-flex d-sm-block bg-white justify-content-center align-items-center col-md-12 col-lg-12 mt-3">
      <div class="mx-auto app-login-box col-sm-12 col-md-10 col-lg-9">
        <div class="app-logo"></div>
        <h4 class="mb-1">
          <div style="font-weight: bold;color: #333333;">Welcome,</div>
          <span>It only takes a <span class="text-success">few seconds</span> to
            create your account</span>
        </h4>
        <div>
          <form [formGroup]="registerForm" #form style="font-size: medium;font-weight: 600;">
            <!-- <label class="register-label-title text-primary">Basic Information</label> -->
            <div class="register-group p-3">
              <div class="row">
                <div class="col-md-12">
                  <fieldset class="form-group" id="__BVID__136">
                    <div tabindex="-1" role="group">
                      <label for="businessName">Business Name<span class="text-danger">*</span> </label><input
                        id="businessName" name="businessName" type="text" formControlName="businessName"
                        placeholder=" Business Name here..." class="form-control" />
                    </div>
                    <div *ngIf="
                        registerForm.get('businessName').touched &&
                        registerForm.get('businessName').errors?.required
                      " class="form-control-error errors m-1">
                      Please enter the Business Name..
                    </div>
                  </fieldset>
                </div>
                <div class="col-md-12">
                  <fieldset class="form-group" id="__BVID__138">
                    <div tabindex="-1" role="group">
                      <label for="contactName"> Contact Person Name<span class="text-danger">*</span> </label><input
                        id="contactName" name="contactName" type="text" placeholder="Contact Person Name here.."
                        formControlName="contactName" class="form-control" />
                    </div>
                    <div *ngIf="
                        registerForm.get('contactName').touched &&
                        (registerForm.get('contactName').errors?.required ||
                          registerForm.get('contactName').errors?.pattern)
                      " class="form-control-error errors m-0">
                      Please enter the Contact Person Name ..
                    </div>
                  </fieldset>
                </div>
                <div class="col-md-12">
                  <fieldset class="form-group" id="__BVID__138">
                    <div tabindex="-1" role="group">
                      <label for="designation"> Designation<span class="text-danger">*</span> </label><input
                        id="companyType" name="designation" type="text" placeholder="Designation here.."
                        formControlName="designation" class="form-control" />
                    </div>
                    <div *ngIf="
                        registerForm.get('designation').touched &&
                        (registerForm.get('designation').errors?.required ||
                          registerForm.get('designation').errors?.pattern)
                      " class="form-control-error errors m-0">
                      Please enter the designation ..
                    </div>
                  </fieldset>
                </div>
                <div class="col-md-12">
                  <fieldset class="form-group" id="__BVID__134">
                    <div tabindex="-1" role="group">
                      <label for="phoneno">Phone Number<span class="text-danger">*</span></label><input id="phoneno"
                        name="text" type="text" formControlName="phoneno" placeholder="Phone number here.."
                        class="form-control" />
                    </div>
                    <div *ngIf="
                        registerForm.get('phoneno').touched &&
                        (registerForm.get('phoneno').errors?.required ||
                          registerForm.get('phoneno').errors?.pattern)
                      " class="form-control-error errors m-1">
                      Please enter the valid phone number..
                    </div>
                  </fieldset>
                  <div class="note">
                    * Please Enter International Phone No Format (i.e. +#Country
                    code##Contact No# Ex. +919880000000)
                  </div>
                </div>
                <div class="col-md-12">
                  <fieldset class="form-group" id="__BVID__132">
                    <div tabindex="-1" role="group">
                      <label for="exampleEmail">Email<span class="text-danger">*</span>
                      </label>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="basic-addon1">@</span>
                        </div>

                        <input id="exampleEmail" name="email" type="email" formControlName="emailId"
                          placeholder="Email here..." class="form-control" />
                      </div>

                      <div *ngIf="
                          registerForm.get('emailId').touched &&
                          (registerForm.get('emailId').errors?.required ||
                            registerForm.get('emailId').errors?.pattern)
                        " class="form-control-error errors m-0">
                        Please enter the valid Email address..
                      </div>
                    </div>
                  </fieldset>
                </div>

                <!-- <div class="col-md-6">
                  <fieldset class="form-group" id="__BVID__138">
                    <div tabindex="-1" role="group"><label for="companyCategory">
                        Company Category
                      </label><input id="companyCategory" name="companyCategory" type="text"
                        placeholder="Company Category here..." formControlName="companyCategory" class="form-control">
                    </div>
                    <div
                    *ngIf="registerForm.get('companyCategory').touched && registerForm.get('companyCategory').errors?.required "
                    class="form-control-error errors m-1">Please enter the Company Category..</div>

                  </fieldset>
                </div>
                <div class="col-md-6">
                  <fieldset class="form-group" id="__BVID__138">
                    <div tabindex="-1" role="group"><label for="companyType"><span class="text-danger">*</span>
                        Company Type
                      </label><input id="companyType" name="companyType" type="text" placeholder="Company Type here..."
                        formControlName="companyType" class="form-control"></div>
                        <div
                    *ngIf="registerForm.get('companyType').touched && registerForm.get('companyType').errors?.required "
                    class="form-control-error errors m-1">Please enter the Company Type..</div>

                  </fieldset>
                </div>
               

                <div class="col-md-6">
                  <fieldset class="form-group" id="__BVID__138">
                    <div tabindex="-1" role="group"><label for="website">
                        Website
                      </label><input id="website" name="website" type="text" placeholder="Website here..."
                        formControlName="website" class="form-control"></div>
                  </fieldset>
                </div>
                <div class="col-md-6">
                  <fieldset class="form-group" id="__BVID__138">
                    <div tabindex="-1" role="group"><label for="registrationNumber">
                        Registration Number
                      </label><input id="registrationNumber" name="registrationNumber" type="text"
                        placeholder="Registration Number here..." formControlName="registrationNumber"
                        class="form-control">
                    </div>
                  </fieldset>
                </div> -->
              </div>
            </div>
            <!-- <label class="register-label-title text-primary">Communication Information</label> -->
            <!-- <div class="register-group p-3">
                <div class="row">
                  <div class="col-md-12">
                    <fieldset class="form-group" id="__BVID__138">
                      <div tabindex="-1" role="group"><label for="address">
                          Address
                        </label> <textarea id="address" name="address" rows="4" formControlName="address"
                          placeholder="Address here..." class="form-control"></textarea></div>
                    </fieldset>
                  </div>
                  <div class="col-md-6">
                    <fieldset class="form-group" id="__BVID__138">
                      <div tabindex="-1" role="group"><label for="city">
                          City
                        </label><input id="city" name="city" type="text" formControlName="city" placeholder="City here..."
                          class="form-control"></div>
                    </fieldset>
                  </div>
                  <div class="col-md-6">
                    <fieldset class="form-group" id="__BVID__138">
                      <div tabindex="-1" role="group"><label for="state">
                          State </label><input id="state" name="state" type="text" placeholder="State here..."
                          formControlName="state" class="form-control"></div>
                    </fieldset>
                  </div>
                  <div class="col-md-6">
                    <fieldset class="form-group">
                      <div tabindex="-1" role="group"><label for="country">Country<span class="required">*</span></label>
                        <ng-select [items]="countries" formControlName="country" bindLabel="name" bindValue="name"
                          [placeholder]="'Select Country'">
                        </ng-select>
                      </div>
                      <div *ngIf="registerForm.get('country').touched && registerForm.get('country').errors?.required"
                        class="form-control-error errors m-1">Please select the country..</div>
                    </fieldset>
                  </div>
                  <div class="col-md-6">
                    <fieldset class="form-group" id="__BVID__138">
                      <div tabindex="-1" role="group"><label for="postalCode">
                          Postal Code
                        </label><input id="postalCode" name="postalCode" type="text" placeholder="Postal Code here..."
                          formControlName="postalCode" class="form-control"></div>
                    </fieldset>
                  </div>
                  </div>
                </div> -->

            <div class="custom-control custom-checkbox mt-4">
              <input id="exampleCheck" type="checkbox" name="check" autocomplete="off" class="custom-control-input"
                [(ngModel)]="terms" [ngModelOptions]="{ standalone: true }" /><label for="exampleCheck"
                class="custom-control-label">

                Accept our <a href="/pages/terms-condition" target="_blank">Terms and Conditions</a> / <a
                  href="/pages/privacy-policy" target="_blank">Privacy Policy</a>.
              </label>


            </div>
            <div class="mt-1 d-flex align-items-center">
              <label class="mb-0">
                Already have an account?
                <a href="pages/login" class="text-primary">Sign in</a>
              </label>
              <div class="ml-auto mb-3">
                <button type="button" (click)="registerUser()"
                  class="btn btn-wide btn-pill btn-shadow btn-hover-shine btn-info btn-lg"
                  style="background-color: #0f2c92 !important;border-color: #0f2c92 !important;color: #fff !important;">
                  Create Account
                </button>
              </div>
            </div>
          </form>
        </div>
        <div style="position:fixed; bottom:0; width:60%; height:auto; margin-top:40px;text-align:center">
          <app-footer [needHelp]="false"></app-footer>
        </div>
      </div>

    </div>

  </div>

</div>